import React from "react"
import useMediaQuery from '@mui/material/useMediaQuery'
import { Table } from "react-bootstrap"
import { formatMoney, formatDiscountPercent } from "../../helpers/utils"
import ClientHeader from "../../components/ClientHeader/ClientHeader"
import DetailsSummarySection from '../../components/details/summary/DetailsSummarySection'
import DetailStatusMobileHeader from '../../components/DetailStatusMobileHeader'
import TotalsSummaryCard from '../../components/TotalsSummaryCard'
import { INVOICE_HEADER_CONFIG } from "../constants/orderConstants"
import { buildInvoiceFields } from "../helpers/invoiceOrderHelpers"
import { layoutMobileMediaQuery } from '../../layout/layoutConstants'
import OrderInvoiceDetailsTabMobileLines from '../mobile/OrderInvoiceDetailsTabMobileLines'

const OrderInvoiceDetailsTab = ({
  invoiceAppDetails,
  statusUI,
  fallbackStatus,
  showStatusInHeader = false,
}) => {
  if (!invoiceAppDetails) return null

  const fields = buildInvoiceFields(invoiceAppDetails)
  const details = invoiceAppDetails.details ?? []
  const isMobileLayout = useMediaQuery(layoutMobileMediaQuery)
  const totalRows = [
    {
      label: 'SUB-TOTAL:',
      value: formatMoney(Number(invoiceAppDetails.sub_total || 0))
    },
    {
      label: 'DESCUENTOS:',
      value: `-${formatMoney(Number(invoiceAppDetails.discount || 0))}`,
      negative: true
    },
    {
      label: 'TOTAL ITBMS:',
      value: formatMoney(Number(invoiceAppDetails.taxes || 0))
    },
    {
      label: 'TOTAL:',
      value: formatMoney(Number(invoiceAppDetails.invoice_total || 0)),
      strong: true,
      dividerBefore: true
    },
    {
      label: 'PESO TOTAL:',
      value: invoiceAppDetails.total_weight || 'N/A'
    }
  ]

  return (
    <div className="container-fluid px-0">
      {showStatusInHeader ? (
        <DetailStatusMobileHeader
          title="Detalles de factura:"
          statusUI={statusUI}
          fallbackStatus={fallbackStatus}
        />
      ) : (
        <>
          <div className="show-product-header">
            <h3 className="margin-text-subtitle">
              Detalles de factura:
            </h3>
          </div>
          <hr />
        </>
      )}
      <ClientHeader
        data={invoiceAppDetails}
        config={INVOICE_HEADER_CONFIG}
      />
      <hr />
      <DetailsSummarySection
        summaryFields={fields}
        summaryTitle="DETALLES DE FACTURA"
        summaryOpenLabel="Abrir detalles de factura"
        summaryCloseLabel="Cerrar detalles de factura"
      />
      <hr />
      <div className="mr-85 mb-10">
        <b>Productos en factura:</b>
      </div>
      {isMobileLayout ? (
        <OrderInvoiceDetailsTabMobileLines details={details} />
      ) : (
        <Table hover responsive>
          <thead className="table-header-gray-mui">
            <tr>
              <th>CÓDIGO</th>
              <th>NOMBRE DEL PRODUCTO</th>
              <th>PESO NETO</th>
              <th>UNIDAD</th>
              <th>CANTIDAD</th>
              <th>PRECIO</th>
              <th>% DESCUENTO</th>
              <th>SUB-TOTAL</th>
            </tr>
          </thead>
          <tbody>
            {details && details.length > 0 ? (
              details.map((model, index) => (
                <tr key={index}>
                  <td className="order-td-text">{model.product_db_ref}</td>
                  <td className="order-td-text">{model.product_name}</td>
                  <td className="order-td-money">
                    {Number(model.net_weight || 0) === 0
                      ? "-"
                      : Number(model.net_weight).toFixed(2)}
                  </td>
                  <td className="order-td-text">{model.unit}</td>
                  <td className="order-td-money">
                    {Number(model.quantity || 0).toFixed(2)}
                  </td>
                  <td className="order-td-money">
                    {formatMoney(Number(model.unit_price || 0))}
                  </td>
                  <td className="order-td-money">
                    {formatDiscountPercent(model.discount)}
                  </td>
                  <td className="order-td-money">
                    {formatMoney(Number(model.extended_price || 0))}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="order-td-text">
                  No hay resultados
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
      <TotalsSummaryCard rows={totalRows} />
    </div>
  )
}

export default OrderInvoiceDetailsTab
